import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Clock = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Clock' {...props}>
    <path fillRule='evenodd' clipRule='evenodd' d='M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V12C11 12.3148 11.1482 12.6111 11.4 12.8L15.4 15.8C15.8418 16.1314 16.4686 16.0418 16.8 15.6C17.1314 15.1582 17.0418 14.5314 16.6 14.2L13 11.5V7Z' fill='#000' />
  </StyledIcon>
);
